"use strict";
var ng2_collapsable_component_1 = require("./ng2-collapsable.component");
exports.Ng2CollapsableComponent = ng2_collapsable_component_1.Ng2CollapsableComponent;
var ng2_collapsable_module_1 = require("./ng2-collapsable.module");
exports.Ng2CollapsableModule = ng2_collapsable_module_1.Ng2CollapsableModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-collapsable/dist/index.js
// module id = 65
// module chunks = 0